import {Component, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';
import {Shared} from "../../../shared/shared";
import {CourseService} from "../../../../service/CourseService";
import {BooleanComponent} from "../../generic/table/booleanComponent/booleanComponent";
import {CalendarComponent} from "../../generic/table/calendarComponent/calendarComponent";
import {TextComponent} from "../../generic/table/textComponent/textComponent";
import {DropdownComponent} from "../../generic/table/dropdownComponent/dropdownComponent";
import {ModalityEntity} from "../../../../model/ModalityEntity";
import {CourseTypeEntity} from "../../../../model/CourseTypeEntity";
import {CourseEntity} from "../../../../model/CourseEntity";
import {SiteEntity} from "../../../../model/SiteEntity";
import {ButtonComponent} from "../../generic/table/buttonComponent/buttonComponent";
import {TurnEntity} from "../../../../model/TurnEntity";
import * as moment from 'moment-timezone';
import {BasicDto} from "../../../../dto/BasicDto";
import {ContextService} from "../../../../service/ContextService";
import {CourseFrontPageEntity} from "../../../../model/CourseFrontPageEntity";
import {AngularEditorConfig} from "@kolkov/angular-editor";
import {PermissionRoleEntity} from "../../../../model/PermissionRoleEntity";
import {CommonCourseDto} from "../../../../dto/CommonCourseDto";
import {StaticCalendarEntity} from "../../../../model/StaticCalendarEntity";

@Component({
  selector: 'app-site',
  templateUrl: 'site.html',
  styleUrls: [],
  encapsulation: ViewEncapsulation.None
})
export class Site {

  @Input() sites: SiteEntity[];
  @Input() modalities: ModalityEntity[];
  @Input() coursesType: CourseTypeEntity[];
  @Input() courses: CourseEntity[];

  @Input() commonCourse: CommonCourseDto;

  @Output() filter = new EventEmitter<number>();

  aux: ModalityEntity[];
  roles: BasicDto[];
  staticCalendars: StaticCalendarEntity[];
  staticCalendarsFiltered: StaticCalendarEntity[];

  newEntity: SiteEntity;
  modeAdd = false;

  showStartDate = false;
  showEndDate = false;
  showOpenSignupDate = false;
  showCloseSignupDate = false;
  showSettings = false;
  showCustomize = false;

  currentSite: SiteEntity;
  currentCourseFrontPage: CourseFrontPageEntity;

  availableParents: any = [];
  permissionSettings = false;

  parentId: number;
  parentType: string;
  currentParentRole: number;

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '0',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: false,
    showToolbar: true,
    placeholder: 'Enter text here...',
    fonts: [
      {class: 'arial', name: 'Arial'},
    ],
    sanitize: false,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      ['indent', 'outdent', 'superscript', 'subscript', 'link', 'unlink', 'insertImage', 'insertVideo', 'strikeThrough', 'fontName'],
    ]
  };

  headers: any = {
    columns: {
      alias: {title: 'Alias', hide: false, filter: true, type: "custom",
        valuePrepareFunction: (cell, row) => cell,
        renderComponent: TextComponent,
        onComponentInitFunction: (instance) => {
          if (instance != null) {
            instance.changeText.subscribe(data => {
              let site = this.sites.find(x => x.id == data.row.id)
              site.alias = data.text;
              this.saveSite(site, false);
            });
          }
        },
      },
      name: {title: 'Name', hide: false, filter: true, type: "custom",
        valuePrepareFunction: (cell, row) => cell,
        renderComponent: TextComponent,
        onComponentInitFunction: (instance) => {
          if (instance != null) {
            instance.changeText.subscribe(data => {
              let site = this.sites.find(x => x.id == data.row.id)
              site.name = data.text;
              this.saveSite(site, false);
            });
          }
        },
      },
      modalityId: {title: 'Modality', hide: false, filter: true, type: "custom",
        valuePrepareFunction: (cell, row) => { return {cell: cell, options: this.aux}},
        renderComponent: DropdownComponent,
        onComponentInitFunction: (instance) => {
          if (instance != null) {
            instance.changeDropdown.subscribe(data => {
              let site = this.sites.find(x => x.id == data.row.id)
              site.modalityId = data.id;
              this.saveSite(site, false);
            });
          }
        },
      },
      startDate: {
        title: 'Start date', hide: false, filter: true, editable: true, type: "custom",
        valuePrepareFunction: (cell, row) => cell,
        renderComponent: CalendarComponent,
        onComponentInitFunction: (instance) => {
          if (instance != null) {
            instance.changeCalendar.subscribe(data => {
              let site = this.sites.find(x => x.id == data.row.id)
              site.startDate = data.date;
              this.saveSite(site, false);
            });
          }
        },
      },
      endDate: {
        title: 'End date', hide: false, filter: true, editable: true, type: "custom",
        valuePrepareFunction: (cell, row) => cell,
        renderComponent: CalendarComponent,
        onComponentInitFunction: (instance) => {
          if (instance != null) {
            instance.changeCalendar.subscribe(data => {
              let site = this.sites.find(x => x.id == data.row.id)
              site.endDate = data.date;
              this.saveSite(site, false);
            });
          }
        },
      },
      openSignupDate: {
        title: 'Open signup date', hide: true, filter: true, editable: true, type: "custom",
        valuePrepareFunction: (cell, row) => cell,
        renderComponent: CalendarComponent,
        onComponentInitFunction: (instance) => {
          if (instance != null) {
            instance.changeCalendar.subscribe(data => {
              let site = this.sites.find(x => x.id == data.row.id)
              site.openSignupDate = data.date;
              this.saveSite(site, false);
            });
          }
        },
      },
      closeSignupDate: {
        title: 'Close signup date', hide: true, filter: true, editable: true, type: "custom",
        valuePrepareFunction: (cell, row) => cell,
        renderComponent: CalendarComponent,
        onComponentInitFunction: (instance) => {
          if (instance != null) {
            instance.changeCalendar.subscribe(data => {
              let site = this.sites.find(x => x.id == data.row.id)
              site.closeSignupDate = data.date;
              this.saveSite(site, false);
            });
          }
        },
      },
      defaultRole: {
        title: 'Default role', hide: false, filter: true, type: "custom",
        valuePrepareFunction: (cell, row) => {
          return {cell: cell, options: this.roles}
        },
        renderComponent: DropdownComponent,
        onComponentInitFunction: (instance) => {
          if (instance != null) {
            instance.changeDropdown.subscribe(data => {
              let site = this.sites.find(x => x.id == data.row.id)
              site.defaultRole = data.id;
              this.saveSite(site, false);
            });
          }
        },
      },
      contentNotification: {
        title: 'Content notification', hide: false, filter: true, type: "custom",
        valuePrepareFunction: (cell, row) => cell,
        renderComponent: BooleanComponent,
        onComponentInitFunction: (instance) => {
          if (instance != null) {
            instance.changeBool.subscribe(data => {
              let site = this.sites.find(x => x.id == data.row.id)
              site.contentNotification = data.bool;
              this.saveSite(site, false);
            });
          }
        },
      },
      showInRegister: {
        title: 'Show in Register', hide: false, filter: true, type: "custom",
        valuePrepareFunction: (cell, row) => cell,
        renderComponent: BooleanComponent,
        onComponentInitFunction: (instance) => {
          if (instance != null) {
            instance.changeBool.subscribe(data => {
              let site = this.sites.find(x => x.id == data.row.id)
              site.showInRegister = data.bool;
              this.saveSite(site, false);
            });
          }
        },
      },
      showInCampus: {
        title: 'Show in Campus', hide: false, filter: true, type: "custom",
        valuePrepareFunction: (cell, row) => cell,
        renderComponent: BooleanComponent,
        onComponentInitFunction: (instance) => {
          if (instance != null) {
            instance.changeBool.subscribe(data => {
              let site = this.sites.find(x => x.id == data.row.id)
              site.showInCampus = data.bool;
              this.saveSite(site, false);
            });
          }
        },
      },
      showInMagnament: {
        title: 'Show in Magnament', hide: true, filter: true, type: "custom",
        valuePrepareFunction: (cell, row) => cell,
        renderComponent: BooleanComponent,
        onComponentInitFunction: (instance) => {
          if (instance != null) {
            instance.changeBool.subscribe(data => {
              let site = this.sites.find(x => x.id == data.row.id)
              site.showInMagnament = data.bool;
              this.saveSite(site, false);
            });
          }
        },
      },
      id: {title: '', hide: false, filter: false, type: "custom",
        valuePrepareFunction: (cell, row) => {
          return {cell: cell, icon: 'arrow-redo-outline', text: '', color: ''}
        },
        renderComponent: ButtonComponent,
        onComponentInitFunction: (instance) => {
          if (instance != null) {
            instance.changeButton.subscribe(data => {
              this.nextStep(data);
            });
          }
        },
      },
      corpId: {
        title: '', hide: false, filter: false, type: "custom",
        valuePrepareFunction: (cell, row) => {
          return {cell: row.id, icon: 'brush-outline', text: '', color: ''}
        },
        renderComponent: ButtonComponent,
        onComponentInitFunction: (instance) => {
          if (instance != null) {
            instance.changeButton.subscribe(data => {
              this.customizeCourse(data);
              this.showCustomize = true;
            });
          }
        },
      },
      row2: {title: '', hide: false, filter: false, type: "custom",
        valuePrepareFunction: (cell, row) => {
          return {cell: row.id, icon: 'copy-outline', text: '', color: ''}
        },
        renderComponent: ButtonComponent,
        onComponentInitFunction: (instance) => {
          if (instance != null) {
            instance.changeButton.subscribe(data => {
              this.cloneSite(data);
            });
          }
        },
      },
      row3: {title: '', hide: false, filter: false, type: "custom",
        valuePrepareFunction: (cell, row) => {
          return {cell: row.id, icon: 'settings-outline', text: '', color: ''}
        },
        renderComponent: ButtonComponent,
        onComponentInitFunction: (instance) => {
          if (instance != null) {
            instance.changeButton.subscribe(data => {
              this.openSettingsDiv(data);
              this.showSettings=true;
            });
          }
        },
      },
      row4: {
        title: '', hide: false, filter: false, type: "custom",
        valuePrepareFunction: (cell, row) => {
          return {cell: row.id, icon: 'shield-outline', text: '', color: ''}
        },
        renderComponent: ButtonComponent,
        onComponentInitFunction: (instance) => {
          if (instance != null) {
            instance.changeButton.subscribe(data => {
              let site = this.sites.find(x => x.id == data);
              this.parentType = 'SITE';
              this.parentId = site.id;
              this.currentParentRole = site.defaultRole;
              this.permissionSettings = true;
            });
          }
        },
      },
    },
    actions: false,
  }

  constructor(private courseService: CourseService, private contextService: ContextService, private shared: Shared) {
  }

  ngOnInit() {
    this.aux = this.modalities.map(x=> {
      let courseType = this.coursesType.find(y=> y.id == x.courseTypeId)
      let course = this.courses.find(p=> p.id == courseType.courseId);
      x.name = x.name+" ("+courseType.alias+" - "+course.alias+")";
      return x;
    });

    this.roles = this.commonCourse.roles;
    this.staticCalendars = this.commonCourse.staticCalendars;
    this.staticCalendars.forEach(item => {
      item.alias = item.name;
    });
  }

  customizeCourse(id: number) {
    this.currentSite = this.sites.find(x => x.id == id);
    this.currentCourseFrontPage = new CourseFrontPageEntity();
    this.currentCourseFrontPage.corpId = this.shared.CORP_ID;
    this.currentCourseFrontPage.siteId = id;
    this.currentCourseFrontPage.html = "";
    this.currentCourseFrontPage.backgroundImage = "";
    this.currentCourseFrontPage.enabled = true;
    this.courseService.getCourseFrontPageBySite(this.currentSite.id).subscribe(t => {
      if (t != null) {
        this.currentCourseFrontPage = t;
      }
    });
  }

  openSettingsDiv(id){
    this.currentSite = this.sites.find(p=> p.id == id);
    let m = this.modalities.find(p=> p.id == this.currentSite.modalityId);
    let ct = this.coursesType.find(p=> p.id == m.courseTypeId);
    let c = this.courses.find(p=> p.id == ct.courseId);

    this.staticCalendarsFiltered = this.staticCalendars.filter(x => x.courseId == c.id || x.courseId == null);

    this.availableParents.push({'id':c.id, 'name':c.name, 'type': "COURSE"});
    this.coursesType.filter(ctS=>ctS.courseId == c.id).forEach(ct=>{
      this.availableParents.push({'id': ct.id, 'name': "--"+ct.name, 'type': "COURSE_TYPE"});
      this.modalities.filter(mS=> mS.courseTypeId == ct.id).forEach(m=>{
        this.availableParents.push({'id': m.id, 'name': "-- -- "+m.name, 'type': "MODALITY"});
        this.sites.filter(sS=> sS.modalityId == m.id).forEach(s=>{
          this.availableParents.push({'id': s.id, 'name': "-- -- -- "+s.name, 'type': "SITE"});
        })
      })
    })
  }

  saveCourseFrontPage() {
    this.courseService.saveCourseFrontPage(this.currentCourseFrontPage).subscribe(t => {
      if (t != null) {
        this.currentCourseFrontPage = t;
      }
    });
    this.currentSite = null;
    this.showCustomize = false;
  }


  nextStep(id: number){
    this.filter.emit(id);
  }

  cloneSite(id){
    let bool = confirm("¿Estás seguro que deseas duplicar el site?");

    if(bool) {
      this.courseService.cloneSite(id).subscribe((w: SiteEntity[]) => {
        if (w != null) {
          this.sites = w;
        }
      });
    }
  }

  saveSite(site: SiteEntity, bool) {
    if(site.name.indexOf('(')!=-1) {
      site.name = site.name.substr(0,site.name.indexOf('('));
    }
    this.courseService.saveSite(site).subscribe( t =>{
      if(t!=null) {
        if(bool){this.sites.push(t);}
        this.sites = this.sites.filter(x => {return x});
      }
    });
  }

  async saveNewSite() {
    this.saveSite(this.newEntity, true);
    this.modeAdd = false;
  }

  newSite(){
    this.modeAdd = true;
    this.newEntity = new SiteEntity();
    this.newEntity.corpId = this.shared.CORP_ID;
    this.newEntity.showInMagnament = true;
  }

  changeStartDate(event){
    this.newEntity.startDate = moment(event.value).format('yyyy-MM-DDTHH:mm:ss');
  }

  changeEndDate(event){
    this.newEntity.endDate = moment(event.value).format('yyyy-MM-DDTHH:mm:ss');
  }

  changeOpenSingupDate(event){
    this.newEntity.openSignupDate = moment(event.value).format('yyyy-MM-DDTHH:mm:ss');
  }

  changeCloseSingupDate(event){
    this.newEntity.closeSignupDate = moment(event.value).format('yyyy-MM-DDTHH:mm:ss');
  }

  convertFileToBase64DocumentB(evt) {
    let me = this;
    let file = evt.target.files[0];
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      me.currentCourseFrontPage.backgroundImage = reader.result.toString();
    };
  }

  convertFileToBase64DocumentS(evt) {
    let me = this;
    let file = evt.target.files[0];
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      me.currentCourseFrontPage.subscriptionImage = reader.result.toString();
    };
  }

  async closePermissionsWindow(data: PermissionRoleEntity[]){
    this.permissionSettings = false;
    this.roles = null;
    await this.delay(200);
    this.roles = data.map(d=> new BasicDto(d.id, d.alias, d.name, null));
  }

  splitByComma(text) {
    if (text != null) {
      return text.split(',');
    }
    return null;
  }

  delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
}
